import React, { useState } from 'react';

function CredentialsModal({ isOpen, onClose, username, password, title = 'Credentials Generated' }) {
  const [copied, setCopied] = useState({ username: false, password: false });

  if (!isOpen) return null;

  const copyToClipboard = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied({ ...copied, [field]: true });
      setTimeout(() => setCopied({ ...copied, [field]: false }), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const copyBoth = async () => {
    const text = `Username: ${username}\nPassword: ${password}`;
    try {
      await navigator.clipboard.writeText(text);
      setCopied({ username: true, password: true });
      setTimeout(() => setCopied({ username: false, password: false }), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="credentials-warning">
            <strong>⚠️ Important: Save these credentials now!</strong>
            <p>These credentials will not be shown again. Please copy and store them securely.</p>
          </div>

          <div className="credentials-display">
            <div className="credential-item">
              <label>Username</label>
              <div className="credential-field">
                <code>{username}</code>
                <button
                  className="copy-button"
                  onClick={() => copyToClipboard(username, 'username')}
                  title="Copy username"
                >
                  {copied.username ? '✓ Copied' : '📋 Copy'}
                </button>
              </div>
            </div>

            <div className="credential-item">
              <label>Password</label>
              <div className="credential-field">
                <code>{password}</code>
                <button
                  className="copy-button"
                  onClick={() => copyToClipboard(password, 'password')}
                  title="Copy password"
                >
                  {copied.password ? '✓ Copied' : '📋 Copy'}
                </button>
              </div>
            </div>
          </div>

          <div className="modal-actions">
            <button className="secondary-button" onClick={copyBoth}>
              📋 Copy Both
            </button>
            <button className="primary-button" onClick={onClose}>
              I've Saved These Credentials
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CredentialsModal;

